import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import trashIcon from "../../../resources/images/trash-icon.svg";
import checkIcon from "../../../resources/images/check-blue-icon.svg";
import featuredIcon from "../../../resources/images/featured-icon.svg";
import trashRedIcon from "../../../resources/images/trash-red-icon.svg";
import featuredRedIcon from "../../../resources/images/featured-red-icon.svg";

const styles = createUseStyles(theme => ({
  preview: {
    display: "flex",
    width: "100%",
    minHeight: "100px",
    margin: "0 auto",
    position: "relative",
    boxSizing: "border-box",
    transition: "all .15s linear",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "14px",
  },
  previewError: {
    extend: "preview",
    border: "1px solid " + colors.mediumRed,
    backgroundColor: colors.veryLightRed
  },
  content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "0px 0px 0px 14px",
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  progressBarWrapper: {
    display: "flex",
    alignItems: "center",
  },
  progressBar: {
    inlineSize: "100%",
    marginRight: "10px",
    accentColor: theme.progress.accentColor,
  },
  staticProgress:{
    width: "85%",
    marginTop :"20px",
    height: "9px",
    borderRadius: "10px",
    backgroundColor: theme.progress.backgroundColor,
  },
  fileIcon: {
    backgroundSize: "32px 32px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "36px",
    height: "36px",
    backgroundImage: theme.uploadModal.backgroundImage
  },
  fileRedIcon: {
    extend: "fileIcon",
    backgroundImage: `url(${featuredRedIcon})`
  },
  icon: {
    backgroundSize: "20px 20px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "25px",
    height: "25px",
    backgroundImage: `url(${checkIcon})`
  },
  cancelIcon: {
    extend: ["icon", "thrashIconHover"],
    cursor: "pointer",
    backgroundImage: `url(${trashIcon})`,
    "&:hover": {
      backgroundColor: colors.brightBlue
    },
  },
  cancelRedIcon: {
    extend: ["icon", "thrashIconHover"],
    cursor: "pointer",
    backgroundImage: `url(${trashRedIcon})`,
    paddingLeft: "8px",
    "&:hover": {
      backgroundColor: colors.lightRed
    },
  },
  thrashIconHover: {
    width: "36px",
    height: "36px",
    position: "absolute",
    right: 6,
    borderRadius: "10px",
  },
  errorMessage: {
    fontSize: "14px",
    color: colors.darkRed,
    fontWeight: "500",
  },
  tryAgain: {
    fontSize: "14px",
    color: colors.darkRed,
    fontWeight: "600",
    marginTop: "4px",
    cursor: "pointer"
  },
  title: {
    fontSize: "14px",
    color: colors.grey,
    fontWeight: "500",
  },
  titleError: {
    fontSize: "14px",
    color: colors.brightRed,
    fontWeight: "400",
  },
  progressDiv: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "& .progress": {
      height: "8px",
      width: "100%",
      backgroundColor: theme.progress.backgroundColor,
      "& .progress-bar": {
        backgroundColor: theme.progress.accentColor,
        borderRadius: "6px"
      },
    },
  },
}))

export default styles;
